import theme from "@/styles/theme";
import { Container, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { NetworkPersonCard } from "../network";

export const AboutTeam = ({content}) => {

    return (
      <Container maxWidth="xl">
        <Grid
          container
          justifyContent="center"
          sx={{
            backgroundColor: `${
              content.background_color === "lightgrey"
                ? grey[100]
                : content.background_color === "white"
                ? theme.palette.common.white
                : ""
            } !important`,
            py: 3,
            [theme.breakpoints.up("md")]: {
              py: 6,
            },
          }}
        >
          <Grid item xs={10}>
            <Typography
              variant="h3"
              align="center"
              color="common.black"
              component="p"
              sx={{
                mb: 3,
                [theme.breakpoints.up("md")]: {
                  mb: 6,
                },
              }}
            >
              Das Team
            </Typography>
            <Grid container spacing={3} justifyContent="center">
              {content.Person.map((person) => {
                return (
                  <Grid key={person.id} item xs={12} md={6} lg={3}>
                    <NetworkPersonCard
                      name={person.name}
                      role={person.position}
                      photo={person.photo}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
    
}

export default AboutTeam;